import { DELIVERY_PROVINCES, getDeliveryAreasForProvince } from './dashboardAvailability';

export const citySlug = (city) => city.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const getProvinceById = (provinceId) => DELIVERY_PROVINCES.find((province) => province.id === provinceId);

export const getCityLocation = (slug) => DELIVERY_PROVINCES.flatMap((province) => getDeliveryAreasForProvince(province.id).map((city) => ({ city, provinceId: province.id }))).find((location) => citySlug(location.city) === slug);

const asLocationList = (value) => {
  if (Array.isArray(value)) return value;
  if (!value || typeof value !== 'object') return [];
  return Object.values(value).flatMap((entry) => Array.isArray(entry) ? entry : []);
};

export const productProvinces = (product) => {
  const provinces = asLocationList(product.availableProvinces);
  return (provinces.length ? provinces : ['ontario']).map((province) => String(province).toLowerCase());
};

export const productCities = (product, provinceId) => {
  const availableCities = product.availableCities;
  if (Array.isArray(availableCities) && availableCities.length) return availableCities;
  if (availableCities && typeof availableCities === 'object') {
    const provinceCities = availableCities[provinceId] || availableCities[String(provinceId).toLowerCase()];
    if (Array.isArray(provinceCities) && provinceCities.length) return provinceCities;
    const allCities = asLocationList(availableCities);
    if (allCities.length) return allCities;
  }
  return getDeliveryAreasForProvince(provinceId);
};

export const isProductAvailableInProvince = (product, provinceId) => productProvinces(product).includes(provinceId);

export const isProductAvailableInCity = (product, provinceId, city) => isProductAvailableInProvince(product, provinceId) && productCities(product, provinceId).includes(city);

export const availableProvincesForCart = (items) => DELIVERY_PROVINCES.filter((province) => items.every((item) => isProductAvailableInProvince(item, province.id)));

export const availableCitiesForCart = (items, provinceId) => getDeliveryAreasForProvince(provinceId).filter((city) => items.every((item) => isProductAvailableInCity(item, provinceId, city)));

export const LOCATION_ART = {
  ontario: { landmark: 'CN Tower & Toronto skyline', tone: 'from-[#172554] via-[#1d4ed8] to-[#38bdf8]' },
  alberta: { landmark: 'Rocky Mountains & Calgary skyline', tone: 'from-[#14532d] via-[#16a34a] to-[#bbf7d0]' },
  'british-columbia': { landmark: 'Vancouver harbour & coastal mountains', tone: 'from-[#0f766e] via-[#14b8a6] to-[#99f6e4]' },
  quebec: { landmark: 'Old Québec & St. Lawrence River', tone: 'from-[#7c2d12] via-[#ea580c] to-[#fed7aa]' },
};
